export const ROUTE_INDEX = '/'

// orders list
export const ROUTE_ORDERS = '/:brandSlug/orders/list'

// orders on map
export const ROUTE_ORDERS_ON_MAP = '/:brandSlug/orders/map'
// user settings
export const ROUTE_SETTINGS = '/settings'

// brand settings
export const ROUTE_BRAND_SETTINGS = '/:brandSlug/settings'

// orders crud
export const ROUTE_ORDERS_CREATE_ORDER = '/:brandSlug/orders/make'
export const ROUTE_ORDERS_EDIT_ORDER = '/:brandSlug/orders/edit/:orderId'
export const ROUTE_ORDERS_VIEW_ORDER = '/:brandSlug/orders/view/:orderId'


// feedback
export const ROUTE_FEEDBACK_VIEW_FEEDBACK =
  '/:brandSlug/orders/feedbacks/view/:feedbackId'
export const ROUTE_ORDERS_FEEDBACKS = '/:brandSlug/orders/feedbacks/list'

// shops
export const ROUTE_SHOPS = '/:brandSlug/shops'
export const ROUTE_SHOPS_EDIT_SHOP = '/:brandSlug/shops/edit/:shopId'
export const ROUTE_SHOPS_CREATE_SHOP = '/:brandSlug/shops/create'

// shop feedbacks
export const ROUTE_SHOPS_FEEDBACKS = '/:brandSlug/shops/feedbacks'

// shop tags
export const ROUTE_SHOP_TAGS = '/:brandSlug/shopTags'
export const ROUTE_SHOP_TAGS_EDIT = '/:brandSlug/shopTags/edit/:shopTagId'
export const ROUTE_SHOP_TAGS_CREATE = '/:brandSlug/shopTags/create'

// devices
export const ROUTE_DEVICES = '/:brandSlug/devices'
export const ROUTE_DEVICES_EDIT_DEVICE = '/:brandSlug/devices/edit/:deviceId'
export const ROUTE_DEVICES_CREATE_DEVICE = '/:brandSlug/devices/create'

// storage containers
export const ROUTE_STORAGE_CONTAINERS = '/:brandSlug/storage-containers'
export const ROUTE_STORAGE_CONTAINERS_CREATE = '/:brandSlug/storage-containers/create'
export const ROUTE_STORAGE_CONTAINERS_BATCH_CREATE = '/:brandSlug/storage-containers/batch-create'
export const ROUTE_STORAGE_CONTAINERS_EDIT = '/:brandSlug/storage-containers/edit/:containerId'

// Logistics
export const ROUTE_LOGISTIC = '/:brandSlug/logistics'

export const ROUTE_LOGISTIC_DASHBOARD = `${ROUTE_LOGISTIC}/dashboard`

// Delivery zones
export const ROUTE_DELIVERY_ZONES = `${ROUTE_LOGISTIC}/deliveryZones`
export const ROUTE_DELIVERY_ZONES_ON_MAP = `${ROUTE_LOGISTIC}/deliveryZones/map`
export const ROUTE_DELIVERY_ZONES_LIST = `${ROUTE_LOGISTIC}/deliveryZones/list`
export const ROUTE_DELIVERY_ZONES_EDIT = `${ROUTE_LOGISTIC}/deliveryZones/edit/:zoneId`
export const ROUTE_DELIVERY_ZONES_CREATE = `${ROUTE_LOGISTIC}/deliveryZones/create`

// Courier management
export const ROUTE_LOGISTIC_COURIERS = `${ROUTE_LOGISTIC}/couriers`
export const ROUTE_LOGISTIC_SINGLE_COURIER = `${ROUTE_LOGISTIC_COURIERS}/:courierId`
export const ROUTE_LOGISTIC_SHIFTS_PLANNER = `${ROUTE_LOGISTIC}/shifts/planner`

// Delivery slots
export const ROUTE_LOGISTIC_SLOTS = `${ROUTE_LOGISTIC}/slots`
export const ROUTE_LOGISTIC_EDIT_SLOT = `${ROUTE_LOGISTIC}/slots/edit/:slotId`

// Vehicles
export const ROUTE_LOGISTIC_VEHICLES = `${ROUTE_LOGISTIC}/vehicles`
export const ROUTE_LOGISTIC_VEHICLES_SINGLE = `${ROUTE_LOGISTIC_VEHICLES}/:vehicleId`
export const ROUTE_LOGISTIC_INCIDENTS = `${ROUTE_LOGISTIC}/vehicles/incidents`

// slots
export const ROUTE_SHOPS_SLOTS = '/:brandSlug/:type/:shopId/slots'
export const ROUTE_SHOPS_EDIT_SLOT = '/:brandSlug/:shopId/slots/edit/:slotId'

// catalog
export const ROUTE_CATALOG = '/:brandSlug/catalog/product'
export const ROUTE_CATALOG_EXPORT = '/:brandSlug/catalog/export'

// product groups
export const ROUTE_PRODUCT_GROUPS = '/:brandSlug/catalog/productGroups'
export const ROUTE_SINGLE_PRODUCT_GROUP = '/:brandSlug/catalog/productGroups/:groupId'
export const ROUTE_PRODUCT_GROUPS_ADD = '/:brandSlug/catalog/productGroups/add'
export const ROUTE_PRODUCT_GROUPS_EDIT = '/:brandSlug/catalog/productGroups/edit/:groupId'

// product attributes
export const ROUTE_PRODUCT_ATTRIBUTES = '/:brandSlug/catalog/productAttributes'
export const ROUTE_PRODUCT_ATTRIBUTES_ADD = '/:brandSlug/catalog/productAttributes/add'
export const ROUTE_PRODUCT_ATTRIBUTES_EDIT = '/:brandSlug/catalog/productAttributes/edit/:attributeId'
export const ROUTE_SINGLE_PRODUCT_ATTRIBUTE = '/:brandSlug/catalog/productAttributes/:attributeId'

// product review crud
export const ROUTE_CATALOG_PRODUCT_REVIEWS =
  '/:brandSlug/catalog/productReview/list'
export const ROUTE_CATALOG_MODERATION_PRODUCT_REVIEWS =
  '/:brandSlug/catalog/productReview/moderation'
export const ROUTE_CATALOG_PRODUCT_REVIEW_EDIT =
  '/:brandSlug/catalog/productReview/edit/:productReviewId'

// product crud
export const ROUTE_CATALOG_PRODUCT_ADD = '/:brandSlug/catalog/product/add'
export const ROUTE_CATALOG_PRODUCT_EDIT =
  '/:brandSlug/catalog/product/edit/:productId'

// category crud
export const ROUTE_CATALOG_CATEGORIES = '/:brandSlug/catalog/category/list'
export const ROUTE_CATALOG_CATEGORY_ADD = '/:brandSlug/catalog/category/add'
export const ROUTE_CATALOG_CATEGORY_EDIT =
  '/:brandSlug/catalog/category/edit/:categoryId'
export const ROUTE_CATALOG_CATEGORY_ORDER = '/:brandSlug/catalog/category/order'
export const ROUTE_CATALOG_CATEGORY_TREE = '/:brandSlug/catalog/category/tree'

// assembling
export const ROUTE_ASSEMBLING_MANAGEMENT = '/:brandSlug/assembling/:type?'
export const ROUTE_ASSEMBLING_ASSEMBLE_ORDER =
  '/:brandSlug/assembling/order/assemble/:orderId'

// user management
export const ROUTE_USERS_MANAGEMENT = '/users/:type?'
export const ROUTE_USERS_MANAGEMENT_ADD = '/users/:type/form/add'
export const ROUTE_USERS_MANAGEMENT_EDIT = '/users/:type/form/edit/:id?'
export const ROUTE_USERS_MANAGEMENT_VIEW_ASSEMBLER = '/users/assemblers/view/:id'

//customers
export const ROUTE_CUSTOMERS = '/:brandSlug/customers'
export const ROUTE_CUSTOMERS_ADD_CUSTOMER = '/:brandSlug/customers/add'
export const ROUTE_CUSTOMERS_EDIT_CUSTOMER =
  '/:brandSlug/customers/edit/:customerId'
export const ROUTE_CUSTOMERS_VIEW_CUSTOMER =
  '/:brandSlug/customers/view/:customerId'

// business profiles
export const ROUTE_BUSINESS_PROFILES = '/:brandSlug/businessProfiles'
export const ROUTE_EDIT_BUSINESS_PROFILE = '/:brandSlug/businessProfiles/edit/:profileId'
export const ROUTE_MODERATE_BUSINESS_PROFILES = '/:brandSlug/businessProfiles/moderate'
// marketing
export const ROUTE_MARKETING_MANAGEMENT = '/:brandSlug/marketing/:type?'

// text materials
export const ROUTE_TEXT_MATERIALS_MANAGEMENT = '/:brandSlug/textMaterials'
export const ROUTE_TEXT_MATERIALS_ADD = '/:brandSlug/textMaterials/add'
export const ROUTE_TEXT_MATERIALS_EDIT = '/:brandSlug/textMaterials/edit/:textId'

export const ROUTE_TEXT_MATERIALS_CATEGORIES = '/:brandSlug/textMaterials/categories'
export const ROUTE_TEXT_MATERIALS_SINGLE_CATEGORY = '/:brandSlug/textMaterials/categories/:categoryId'
export const ROUTE_TEXT_MATERIALS_CATEGORIES_ADD = '/:brandSlug/textMaterials/categories/add'
export const ROUTE_TEXT_MATERIALS_CATEGORIES_EDIT = '/:brandSlug/textMaterials/categories/edit/:categoryId'

export const ROUTE_TEXT_MATERIALS_TYPES = '/:brandSlug/textMaterials/types'
export const ROUTE_TEXT_MATERIALS_TYPES_ADD = '/:brandSlug/textMaterials/types/add'
export const ROUTE_TEXT_MATERIALS_TYPES_EDIT = '/:brandSlug/textMaterials/types/edit/:typeId'

export const ROUTE_TEXT_MATERIALS_THEMES = '/:brandSlug/textMaterials/themes'
export const ROUTE_TEXT_MATERIALS_THEMES_ADD = '/:brandSlug/textMaterials/themes/add'
export const ROUTE_TEXT_MATERIALS_THEMES_EDIT = '/:brandSlug/textMaterials/themes/edit/:themeId'



//promocode
export const ROUTE_MARKETING_PROMOCODE = '/:brandSlug/marketing/promocodes'
export const ROUTE_MARKETING_PROMOCODE_ADD =
  '/:brandSlug/marketing/promocodes/add'
export const ROUTE_MARKETING_PROMOCODE_EDIT =
  '/:brandSlug/marketing/promocodes/edit/:promocodeId'

//banners
export const ROUTE_MARKETING_BANNERS = '/:brandSlug/marketing/banners'
export const ROUTE_MARKETING_BANNER_ADD = '/:brandSlug/marketing/banners/add'
export const ROUTE_MARKETING_BANNER_EDIT =
  '/:brandSlug/marketing/banners/edit/:bannerId'

// bannerTypes crud
export const ROUTE_MARKETING_BANNER_TYPE = '/:brandSlug/marketing/bannerTypes'
export const ROUTE_MARKETING_BANNER_TYPE_ADD =
  '/:brandSlug/marketing/bannerType/add'
export const ROUTE_MARKETING_BANNER_TYPE_EDIT =
  '/:brandSlug/marketing/bannerType/edit/:bannerTypeId'

//stories
export const ROUTE_MARKETING_STORIES = '/:brandSlug/marketing/stories'
export const ROUTE_MARKETING_STORIES_ADD = '/:brandSlug/marketing/stories/add'
export const ROUTE_MARKETING_STORIES_EDIT =
  '/:brandSlug/marketing/stories/edit/:storyId'

//labels
export const ROUTE_MARKETING_LABELS = '/:brandSlug/marketing/labels'
export const ROUTE_MARKETING_LABEL_ADD = '/:brandSlug/marketing/labels/add'
export const ROUTE_MARKETING_LABEL_EDIT =
  '/:brandSlug/marketing/labels/edit/:labelId'

//loyalty coupon series
export const ROUTE_MARKETING_LOYALTY_COUPONS = '/:brandSlug/marketing/loyaltyCoupons'
export const ROUTE_MARKETING_LOYALTY_COUPON_ADD = '/:brandSlug/marketing/loyaltyCoupons/add'
export const ROUTE_MARKETING_LOYALTY_COUPON_EDIT =
  '/:brandSlug/marketing/loyaltyCoupons/edit/:couponSeriesId'

// main page config
export const ROUTE_MAIN_PAGE_CONFIGS = '/:brandSlug/marketing/mainPageConfigs'
export const ROUTE_MAIN_PAGE_CONFIGS_ADD = '/:brandSlug/marketing/mainPageConfigs/add'
export const ROUTE_MAIN_PAGE_CONFIGS_EDIT = '/:brandSlug/marketing/mainPageConfigs/edit/:mainPageConfigId'

// reports
export const ROUTE_REPORTS = '/:brandSlug/reports'

// settings menu management
export const ROUTE_SETTINGS_MENUS = '/settings/menus'
export const ROUTE_SETTINGS_MENUS_CREATE = '/settings/menus/create'
export const ROUTE_SETTINGS_MENUS_EDIT = '/settings/menus/edit/:menuId'
export const ROUTE_SETTINGS_MENU_ITEMS = '/settings/menus/:menuId/items'
export const ROUTE_SETTINGS_MENU_ITEMS_CREATE = '/settings/menus/:menuId/items/create'
export const ROUTE_SETTINGS_MENU_ITEMS_EDIT = '/settings/menus/:menuId/items/edit/:itemId'

// settings topology management
export const ROUTE_SETTINGS_TOPOLOGY = '/settings/topology'
export const ROUTE_SETTINGS_TOPOLOGY_COUNTRY_CREATE = '/settings/topology/country/create'
export const ROUTE_SETTINGS_TOPOLOGY_COUNTRY_EDIT = '/settings/topology/country/:countryId'
export const ROUTE_SETTINGS_TOPOLOGY_REGION_CREATE = '/settings/topology/region/create'
export const ROUTE_SETTINGS_TOPOLOGY_REGION_EDIT = '/settings/topology/region/:regionId'
export const ROUTE_SETTINGS_TOPOLOGY_CITY_CREATE = '/settings/topology/city/create'
export const ROUTE_SETTINGS_TOPOLOGY_CITY_EDIT = '/settings/topology/city/:cityId'

// utils
export const ROUTE_UTIL_PRODUCT_PREVIEW_ADD = '/util/products/preview/add'
export const ROUTE_UTIL_ORDER_RECEIPT_FIX = '/util/orders/receipt/fix'

export const ROUTE_ANY = '*'
